module.exports = __webpack_public_path__ + "img/img26.f84fa398.svg";